<template>
  <div class="app-page--gray layout-highlighted-title">
    <slot/>

    <NuxtPage />

    <div class="absolute -z-10 inset-0 top-0 truncate h-[70vh] bg-slate-200">
      <page-glass/>
      <div class="absolute inset-0 !-bottom-1 bg-gradient-to-b from-white/20 from-70% to-100% to-transparent"/>
    </div>
  </div>
</template>
